import { FeatureFlagBase } from "../../../../../backend/src/graph/feature_flags/feature-flag-base";

export class FeatureFlagEntry extends FeatureFlagBase {
  constructor(baseItem: FeatureFlagBase) {
    super(baseItem.name, baseItem.value);
  }
}
